/**
 * Responsibility: Implement index behavior for the engine layer.
 * Scope: Owns engine-layer concerns only; cross-layer orchestration is excluded.
 */
import { registerDefaultSupervisorChecks } from './checks'

export function registerAllChecks() {
  registerDefaultSupervisorChecks()
}
